import { mapActions } from 'vuex';
import moment from 'moment';

export default {
  data() {
    return {
      events: [],
    };
  },
  async mounted() {
    this.events = await this.fetchUpcomingEvents();
  },
  methods: {
    ...mapActions({
      fetchUpcomingEvents: 'events/fetchUpcomingEvents',
    }),
    toUpcomingEvents(event, award, slug) {
      if (award) {
        this.$router.push({
          name: 'globalAwardsEvents',
          params: { awardId: award, slug },
        });
      } else {
        this.$router.push({
          name: 'standardEvent',
          params: { eventId: event, slug: slug },
        });
      }
    },
    toAllEvents() {
      this.$router.push({ name: 'ccAllEvents' });
    },
    eventDays(start, end) {
      let day = this.moment(start).format('DD');
      if (start !== end) {
        day = `${this.moment(start).format('DD')} - ${this.moment(end).format('DD')}`;
      }
      return day;
    },
    eventMonths(start, end) {
      return this.moment(start).format('MMM') === this.moment(end).format('MMM');
    },
    moment(date) {
      return moment(new Date(date).toUTCString());
    },
  },
};
